import React from "react";
import BlogOverview from "../BlogOverview/BlogOverview";
import { fetchSearchLength, fetchSearchData } from "../../api";
import { useQuery } from "react-query";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilterCircleXmark } from "@fortawesome/free-solid-svg-icons";

function SearchModal({ modalVisible, setModalVisible }) {
  const [searchValue, setSearchValue] = React.useState("");
  const [pageNumber, setPageNumber] = React.useState(0);
  const limit = 2;

  const { data } = useQuery(["search", searchValue, pageNumber, limit], () =>
    fetchSearchData("search", searchValue, pageNumber, limit)
  );

  const { data: length } = useQuery(["searchlength", searchValue], () =>
    fetchSearchLength("searchlength", searchValue)
  );

  //* handle form submit function
  const handleSubmit = (e) => {
    e.preventDefault();

    const searchparameter = e.target[0]?.value;
    setSearchValue(searchparameter);
    setPageNumber(0);
  };

  return (
    <form onSubmit={handleSubmit} id="searchForm">
      <div
        className={`modal fade ${modalVisible ? "show" : ""}`}
        id="searchModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden={!modalVisible}
        data-keyboard
        data-backdrop={modalVisible}
        style={{ display: modalVisible ? "block" : "none" }}
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content search-modal">
            <div className="modal-header text-justify">
              <input
                placeholder="Suche"
                className="form-control form-control-lg dismiss-active-or-focus"
                type="text"
              />
            </div>
            {searchValue && (
              <div className="modal-body">
                {length > 0 ? (
                  <BlogOverview
                    data={data}
                    datalength={length}
                    page={pageNumber}
                    setPage={setPageNumber}
                    limit={limit}
                    search
                    additionalFunction={() => setModalVisible(false)}
                  />
                ) : (
                  <>
                    <div className="no-data-found no-data-found-margin">
                      <FontAwesomeIcon
                        style={{ fontSize: "2em" }}
                        icon={faFilterCircleXmark}
                      />
                    </div>
                    <div className="no-data-found">
                      <p>Keine Daten</p>
                    </div>
                  </>
                )}
              </div>
            )}

            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-toggle="modal"
                data-target="#searchModal"
                onClick={() => setModalVisible(false)}
              >
                Schließen
              </button>
              <button
                type="submit"
                className="btn btn-primary btn-search-custom dismiss-active-or-focus"
              >
                Suchen
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
  );
}

export default SearchModal;
